import { render, staticRenderFns } from "./Workbench.vue?vue&type=template&id=8d825422&scoped=true"
import script from "./Workbench.vue?vue&type=script&lang=js"
export * from "./Workbench.vue?vue&type=script&lang=js"
import style0 from "./Workbench.vue?vue&type=style&index=0&id=8d825422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d825422",
  null
  
)

export default component.exports